Pluswerk.PlusProject.Navigation = {};

/**
 * NavigationController
 *
 * @author Manuel Müller <manuel.mueller@pluswerk.ag>
 */
Pluswerk.PlusProject.Navigation = {
  config: {
    navigationBreakWidth: 1024,
  },
  NavigationController: function () {
    // var $hamburger = $('.js-hamburger');
    // var $navigation = $('.js-navigation');
    // var $ticketHeader = $('.js-ticketHeader');
    // var $navLvl1 = $('.js-lvl1-sub');
    // var $navLvl2 = $('.js-lvl2-sub');
    // var $navLvl3 = $('.js-lvl3-sub');
    // var $navSlideLvl2 = '.html--hasHamburger .js-slide-lvl2';
    // var $navSlideLvl3 = '.html--hasHamburger .js-slide-lvl3';
    // var $navSlideLvl4 = '.html--hasHamburger .js-slide-lvl4';
    // var $navBackLvl2 = '.html--hasHamburger .js-back-lvl2';
    // var $navBackLvl3 = '.html--hasHamburger .js-back-lvl3';
    // var $navBackLvl4 = '.html--hasHamburger .js-back-lvl4';
    // var $mobileSearchToggle = $('.mobile-search-toggle');
    // var $headerSearchBox = $('.header-searchbox');
    //
    // /* We should clean this up when we have time */
    // $mobileSearchToggle.on('click', function () {
    //   $headerSearchBox.toggleClass('toggle-search');
    //   $(this).toggleClass('toggle-search');
    //
    //   if ($headerSearchBox.hasClass('toggle-search')) {
    //     $('#tx-plussolr-search-header .js-solr-q').focus();
    //   }
    // });
    //
    // var setupTicketNavigation = function (windowWidth) {
    //   var $ticketHeader = $('.js-ticketHeader');
    //
    //   /* transform ticketHeader if it would intersect with level1 nav */
    //   if (windowWidth > Pluswerk.PlusProject.Navigation.config.navigationBreakWidth) {
    //     var lastNavItem = $navigation.find($navLvl1).last();
    //     var offsetRight = windowWidth - (lastNavItem.offset().left + lastNavItem.outerWidth());
    //     if (offsetRight <= 500) {
    //       $ticketHeader.addClass('ticketHeader--transformed');
    //     } else {
    //       $ticketHeader.removeClass('ticketHeader--transformed');
    //     }
    //   } else {
    //     $ticketHeader.removeClass('ticketHeader--transformed');
    //   }
    //
    //   /* move ticket header element into header */
    //   var $cartItem = $('.js-tickerHeader__cart')[0];
    //   var $timeItem = $('.js-timeHeader__cart')[0];
    //   var $metaHeader = $('.js-header-meta-height')[0];
    //
    //   if ($metaHeader && !document.querySelector('.header__infoGrid--middle') || (document.querySelector('.header__infoText--date') && document.querySelector('.header__infoText--date').innerHTML === '')) {
    //     $('.js-header-meta-height').addClass('meta--noText');
    //   }
    //
    //   if ($cartItem && $metaHeader && $timeItem) {
    //     if ($($metaHeader).find('.js-tickerHeader__cart').length !== 1) {
    //       $($cartItem).appendTo($metaHeader);
    //     }
    //     if ($($metaHeader).find('.js-timeHeader__cart').length !== 1) {
    //       $($timeItem).appendTo($metaHeader);
    //     }
    //   }
    // };
    //
    // var width = $(window).width();
    // if (width > Pluswerk.PlusProject.Navigation.config.navigationBreakWidth) {
    //   $html.removeClass('html--hasHamburger');
    // } else {
    //   $html.addClass('html--hasHamburger');
    //   if ($html.hasClass('touch')) {
    //     document.addEventListener('touchstart', function () {
    //     }, true);
    //   }
    // }
    //
    // window.addEventListener('load', function () {
    //   setupTicketNavigation(width);
    // });
    //
    // $(window).resize(function () {
    //   var currentWidth = $(window).width();
    //   setupTicketNavigation(currentWidth);
    //   if (currentWidth > Pluswerk.PlusProject.Navigation.config.navigationBreakWidth) {
    //     $html.removeClass('html--hasHamburger');
    //     $body.removeClass('nav-open nav-lvl2-show nav-lvl3-show nav-lvl4-show');
    //     $('.js-lvl1-sub .mainNavigation__itemLink').off('focus');
    //     $navigation.addClass('no-nav-start-animation');
    //   } else {
    //     $html.addClass('html--hasHamburger');
    //   }
    // });
    //
    // $hamburger.on('click', function () {
    //   $headerSearchBox.removeClass('toggle-search');
    //   $mobileSearchToggle.removeClass('toggle-search');
    //   $body.toggleClass('nav-open').removeClass('nav-lvl2-show nav-lvl3-show nav-lvl4-show');
    //   $navigation.removeClass('no-nav-start-animation');
    //   $navLvl1.removeClass('nav-item-open');
    //   $navLvl2.removeClass('nav-item-open');
    //   $navLvl3.removeClass('nav-item-open');
    // });
    //
    // $('.js-lvl1-sub .mainNavigation__itemLink').on('focus',
    //   function (e) {
    //     var $focusTarget = $(e.target);
    //     $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //     $focusTarget.closest('.mainNavigation__item').addClass('mainNavigation__item--open');
    //     $body.addClass('nav-lvl2-open');
    //
    //     $(document).on('keydown', function (e) {
    //       switch (e.key) {
    //         case 'ArrowDown':
    //           e.preventDefault();
    //           processArrowDown($(e.target));
    //           break;
    //         case 'ArrowUp':
    //           e.preventDefault();
    //           processArrowUp($(e.target));
    //           break;
    //         case 'ArrowRight':
    //           e.preventDefault();
    //           processArrowRight($(e.target));
    //           break;
    //         case 'ArrowLeft':
    //           e.preventDefault();
    //           processArrowLeft($(e.target));
    //           break;
    //         case 'Escape':
    //           e.preventDefault();
    //           document.activeElement.blur();
    //           $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //           $('.mainNavigation__subItem--open').removeClass('mainNavigation__subItem--open');
    //           $('.mainNavigation__subSubItem--open').removeClass('mainNavigation__subSubItem--open');
    //           $body.removeClass('nav-open nav-lvl2-open nav-lvl2-show nav-lvl3-show nav-lvl4-show');
    //           $('.js-lvl1-sub .mainNavigation__itemLink').off('focus');
    //           $('.main').first().focus();
    //           break;
    //       }
    //     });
    //   }
    // );
    //
    // var processArrowDown = function ($currentElement) {
    //   if ($currentElement.hasClass('mainNavigation__itemLink')) {
    //     $currentElement.closest('.mainNavigation__item').addClass('mainNavigation__item--open');
    //     $currentElement.parent().find('.mainNavigation__subList .mainNavigation__subItemLink:first').first().focus();
    //     return;
    //   }
    //   var $parentItem = $currentElement.closest('.mainNavigation__subItem');
    //   if ($currentElement.hasClass('mainNavigation__subItemLink')) {
    //     var $nextElement = $parentItem.next('.mainNavigation__subItem').find('.mainNavigation__subItemLink');
    //     if ($nextElement.length) {
    //       $nextElement.first().focus();
    //       return;
    //     }
    //   }
    //   if ($currentElement.hasClass('mainNavigation__subSubItemLink')) {
    //     var $nextElement2 = $currentElement.closest('.mainNavigation__subSubItem').next('.mainNavigation__subSubItem').find('.mainNavigation__subSubItemLink');
    //     if ($nextElement2.length) {
    //       $nextElement2.first().focus();
    //       return;
    //     }
    //   }
    //   if ($currentElement.hasClass('mainNavigation__subSubSubItemLink')) {
    //     var $nextElement3 = $currentElement.closest('.mainNavigation__subSubSubItem').next('.mainNavigation__subSubSubItem').find('.mainNavigation__subSubSubItemLink');
    //     if ($nextElement3.length) {
    //       $nextElement3.first().focus();
    //       return;
    //     }
    //   }
    //   if ($parentItem.hasClass('mainNavigation__subItem--last')) {
    //     var $mainNavigationItem = $parentItem.closest('.mainNavigation__item').next('.mainNavigation__item');
    //     $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //     $mainNavigationItem.addClass('mainNavigation__item--open');
    //     $mainNavigationItem.find('.mainNavigation__itemLink').first().focus();
    //   }
    // };
    //
    // var processArrowUp = function ($currentElement) {
    //   var $parentItem = $currentElement.closest('.mainNavigation__subItem');
    //   if ($parentItem.hasClass('mainNavigation__subItem--first')) {
    //     var $mainNavigationItem = $parentItem.closest('.mainNavigation__item');
    //     $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //     $mainNavigationItem.addClass('mainNavigation__item--open');
    //     $mainNavigationItem.find('.mainNavigation__itemLink').first().focus();
    //     return;
    //   }
    //   if ($currentElement.hasClass('mainNavigation__subItemLink')) {
    //     $parentItem.prev('.mainNavigation__subItem').find('.mainNavigation__subItemLink').first().focus();
    //     return;
    //   }
    //   if ($currentElement.hasClass('mainNavigation__subSubItemLink')) {
    //     var $nextElement = $currentElement.closest('.mainNavigation__subSubItem').prev('.mainNavigation__subSubItem').find('.mainNavigation__subSubItemLink');
    //     if ($nextElement.length) {
    //       $nextElement.first().focus();
    //     }
    //     return;
    //   }
    //   if ($currentElement.hasClass('mainNavigation__subSubSubItemLink')) {
    //     var $nextElement2 = $currentElement.closest('.mainNavigation__subSubSubItem').prev('.mainNavigation__subSubSubItem').find('.mainNavigation__subSubSubItemLink');
    //     if ($nextElement2.length) {
    //       $nextElement2.first().focus();
    //     }
    //     return;
    //   }
    // };
    //
    // var processArrowRight = function ($currentElement) {
    //   // on main level: go to next main menu item
    //   if ($currentElement.hasClass('mainNavigation__itemLink')) {
    //     var $parentItem = $currentElement.closest('.mainNavigation__item');
    //     var $mainNavigationItem = $parentItem.next('.mainNavigation__item');
    //     $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //     $mainNavigationItem.addClass('mainNavigation__item--open');
    //     $mainNavigationItem.find('.mainNavigation__itemLink').first().focus();
    //   } else if ($currentElement.hasClass('mainNavigation__subItemLink')) {
    //     // on submenu: go to submenu of this item
    //     var $parentItem2 = $currentElement.closest('.mainNavigation__subItem');
    //     if ($parentItem2.hasClass('mainNavigation__subItem--hasSub')) {
    //       $parentItem2.addClass('mainNavigation__subItem--open');
    //       $parentItem2.find('.mainNavigation__subSubList .mainNavigation__subSubItemLink:first').first().focus();
    //     }
    //   } else if ($currentElement.hasClass('mainNavigation__subSubItemLink')) {
    //     // on sub submenu: go to submenu of this item
    //     var $parentItem3 = $currentElement.closest('.mainNavigation__subSubItem');
    //     if ($parentItem3.hasClass('mainNavigation__subSubItem--hasSub')) {
    //       $parentItem3.addClass('mainNavigation__subSubItem--open');
    //       $parentItem3.find('.mainNavigation__subSubSubList .mainNavigation__subSubSubItemLink:first').first().focus();
    //     }
    //   }
    // };
    //
    // var processArrowLeft = function ($currentElement) {
    //   var $parentItem = $currentElement.closest('.mainNavigation__item');
    //   // on main level: go to next main menu item
    //   if ($currentElement.hasClass('mainNavigation__itemLink')) {
    //     var $mainNavigationItem = $parentItem.prev('.mainNavigation__item');
    //     $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //     $mainNavigationItem.addClass('mainNavigation__item--open');
    //     $mainNavigationItem.find('.mainNavigation__itemLink').first().focus();
    //   } else if ($currentElement.hasClass('mainNavigation__subSubItemLink')) {
    //     // on submenu: go to parent menu item
    //     var $parentItem2 = $currentElement.closest('.mainNavigation__subItem');
    //       $parentItem2.removeClass('mainNavigation__subItem--open');
    //       $parentItem2.find('.mainNavigation__subItemLink:first').first().focus();
    //   } else if ($currentElement.hasClass('mainNavigation__subSubSubItemLink')) {
    //     // on sub submenu: go to parent menu item
    //     var $parentItem3 = $currentElement.closest('.mainNavigation__subSubItem');
    //       $parentItem3.removeClass('mainNavigation__subSubItem--open');
    //       $parentItem3.find('.mainNavigation__subSubItemLink:first').first().focus();
    //   }
    // };
    //
    // $('.js-lvl1-sub .mainNavigation__itemLink').focusout(
    //   function () {
    //     $body.removeClass('nav-lvl2-open');
    //     $body.removeClass('nav-open nav-lvl2-open nav-lvl2-show nav-lvl3-show nav-lvl4-show');
    //     $('.js-lvl1-sub .mainNavigation__itemLink').off('focus');
    //   }
    // );
    //
    // $('.header__nav').on('mouseleave', function () {
    //   $('.mainNavigation__item--open').removeClass('mainNavigation__item--open');
    //   $('.mainNavigation__subItem--open').removeClass('mainNavigation__subItem--open');
    //   $('.mainNavigation__subSubItem--open').removeClass('mainNavigation__subSubItem--open');
    //   $body.removeClass('nav-open nav-lvl2-open nav-lvl2-show nav-lvl3-show nav-lvl4-show');
    //   $('.js-lvl1-sub .mainNavigation__itemLink').off('focus');
    //   $('.mainNavigation__item').off('focus');
    //   $('.header__nav').off('focus');
    //   $('.main').first().focus();
    //   $('body').focus();
    //   document.activeElement.blur();
    // });
    //
    // $navLvl1.hover(
    //   function () {
    //     $body.addClass('nav-lvl2-open');
    //   },
    //   function () {
    //     $body.removeClass('nav-lvl2-open');
    //   }
    // );
    //
    // $navLvl2.hover(
    //   function () {
    //     $body.addClass('nav-lvl3-open');
    //   },
    //   function () {
    //     $body.removeClass('nav-lvl3-open');
    //   }
    // );
    //
    // $navLvl3.hover(
    //   function () {
    //     $body.addClass('nav-lvl4-open');
    //   },
    //   function () {
    //     $body.removeClass('nav-lvl4-open');
    //   }
    // );
    //
    // $(document).on('click', $navSlideLvl2, function () {
    //   $(this).parent().parent().addClass('nav-item-open');
    //   $body.addClass('nav-lvl2-show');
    // });
    //
    // $(document).on('click', $navSlideLvl3, function () {
    //   $(this).parent().parent().addClass('nav-item-open');
    //   $body.addClass('nav-lvl3-show');
    // });
    //
    // $(document).on('click', $navSlideLvl4, function () {
    //   $(this).parent().parent().addClass('nav-item-open');
    //   $body.addClass('nav-lvl4-show');
    // });
    //
    // $(document).on('click', $navBackLvl2, function () {
    //   $navLvl1.removeClass('nav-item-open');
    //   $navLvl2.removeClass('nav-item-open');
    //   $navLvl3.removeClass('nav-item-open');
    //   $body.removeClass('nav-lvl2-show');
    //   $body.removeClass('nav-lvl3-show');
    //   $body.removeClass('nav-lvl4-show');
    // });
    //
    // $(document).on('click', $navBackLvl3, function () {
    //   $navLvl2.removeClass('nav-item-open');
    //   $navLvl3.removeClass('nav-item-open');
    //   $body.removeClass('nav-lvl3-show');
    //   $body.removeClass('nav-lvl4-show');
    // });
    //
    // $(document).on('click', $navBackLvl4, function () {
    //   $navLvl3.removeClass('nav-item-open');
    //   $body.removeClass('nav-lvl4-show');
    // });
    //
    // var toggleStickyNav = function () {
    //   var height = $('.js-header-meta-height').outerHeight() + $('.js-header-info-height').outerHeight();
    //
    //   if ($(window).scrollTop() >= height) {
    //     $body.addClass('nav--fixed');
    //   } else {
    //     $body.removeClass('nav--fixed');
    //   }
    // };
    //
    // var rafTimer;
    // $(window).on('scroll', function () {
    //   cancelAnimationFrame(rafTimer);
    //   rafTimer = requestAnimationFrame(toggleStickyNav);
    // });
  }
}
